import { prettifyDateTimeHHmm } from 'odfjell-date-time-utils/dateTimeFormatter';
import { StowagePlan } from 'src/types/ViewModel/Stowage/StowagePlan';
import { StowagePlanItemWrapper, StowagePlanItemSubWrapper, StowagePlanListItemTitle, StowagePlanListItemSubtitle } from './PageHeaderStowage.style';
import StowagePlanCommentsButton from './stowagePlanCommentsButton/StowagePlanCommentsButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { ReactNode } from 'react';
import { getStowagePlanTypeTitle } from 'src/utils/stowage/stowagePlanUtils';

interface StowagePlanItemProps {
    stowagePlan: StowagePlan;
    stowagePlanType: string;
}

const getStowagePlanTypeIcon = (stowagePlanType: string) => {
    const iconClass = 'stowage-plan-icon';
    const icons = {
        master: 'ship',
        published: 'share-from-square',
        shared: 'dolly',
        draft: 'pencil-alt',
    };

    return (
        <div className={'initial-mark ' + stowagePlanType} title={getStowagePlanTypeTitle(stowagePlanType)}>
            <FontAwesomeIcon icon={icons[stowagePlanType] as IconProp} className={iconClass} />
        </div>
    );
};

const PageHeaderStowagePlanItem = ({ stowagePlan, stowagePlanType }: StowagePlanItemProps): ReactNode => {
    return (
        <StowagePlanItemWrapper>
            {getStowagePlanTypeIcon(stowagePlanType)}
            <StowagePlanItemSubWrapper>
                <StowagePlanListItemTitle className="text-overflow">
                    M{stowagePlan.masterPlanVersion} {stowagePlan.title}
                </StowagePlanListItemTitle>
                <StowagePlanListItemSubtitle className="text-overflow">
                    Updated {prettifyDateTimeHHmm(stowagePlan.lastUpdatedUtc)} by <i>{stowagePlan.lastUpdatedBy}</i>
                </StowagePlanListItemSubtitle>
            </StowagePlanItemSubWrapper>
            <StowagePlanCommentsButton stowagePlan={stowagePlan} />
        </StowagePlanItemWrapper>
    );
};

export default PageHeaderStowagePlanItem;
